import DayCellRenderer from "./DayCellRenderer";

export default class DayDetailsCellRenderer extends DayCellRenderer {
    constructor(cssBaseClass, cssTopBorderClass) {
        super();
        this.cssBaseClass = cssBaseClass;
        this.cssTopBorderClass = cssTopBorderClass;
    }

    getTopBorderClassName(cell) {
        return this.cssTopBorderClass;
    }

    getComplicatedBorderClassName(cell) {
        let firstRow = cell.getRow().isFirstChildRow();
        let lastRow = cell.getRow().isLastChildRow();
        if (firstRow || lastRow)
            return (firstRow && lastRow) ? "singleDetailsRow" :
                   (firstRow ? "firstDetailsRow" : "lastDetailsRow");
        else
            return "";
    }

    getCellClassName(cell) {
        let className = [this.cssBaseClass];

        if (cell.getRow().getParentRow().isTodayCell(cell))
            className.push("Today");
        else if (cell.getRow().getParentRow().isHolidayCell(cell))
            className.push("Holiday");

        if (this.isLocked(cell))
            className.push("Locked");
        if (this.isApproved(cell))
            className.push("Approved");
        if (this.isSelected(cell))
            className.push("Selected");
        else if (this.isHovered(cell))
            className.push("Hover");
        return className.join(" ");
    }

    isLocked(cell) {
        return cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue().locked;
    }

    isApproved(cell) {
        let approvedValue = cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue().approveInfo;
        return approvedValue && ( approvedValue.approved || approvedValue.autoApproved);
    }

    addTooltip(cell) {
        let leaveInfo = cell.getValue();
        cell.getRow().getTable().getTooltipController().addDayTooltip(cell.getCellEl(),
            cell.getRow().getParentRow().getHeaderCell().getValue().id,
            cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date,
            {showWithoutTime: true, leaveInfo: leaveInfo.leaveInfo, time: leaveInfo.time},
            {showOvertimeWhenZero: false, time: 0, showTime: false, overtimeText: cell.getRow().getHeaderCell().getValue()},
            cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue());
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/DayDetailsCellRenderer.js